// extracted by css-extract-rspack-plugin
module.exports =  {"infoStrip":"nrDz0","totalSeats":"rlaW3","resultStatus":"nIxvP","leadWins":"kNyK3"};